module.exports = __webpack_public_path__ + "img/gb-whatsapp-not-working-cover.5879298b.webp";